function AnalysisCardView() {
    "use strict";
    this.IncidentNumber = '';
    this.StartDate = new Date();
    this.StartDateDisplay = '';
    this.EndDate = new Date('12/31/9999');
    this.EndDateDisplay = '';
    this.OrganizationId = -1;
    this.AgentName = '';
    this.PrimaryOffenseId = -1;
    this.Status = -1;
    this.Data = null;
}
if (typeof exports !== 'undefined') {
    module.exports = AnalysisCardView;
}